<template>
  <!-- eslint-disable vue/singleline-html-element-content-newline -->
  <footer class="footer">
    <div class="footer-container">
      <div class="footer-note">
        <p>
          &copy; 2026
          <router-link to="/" class="footer-link">ogbwhats.com</router-link>
          shares independent guides about OG WhatsApp. Not affiliated with WhatsApp LLC.
        </p>
      </div>
      <div class="footer-links">
        <router-link :to="{ name: 'en-about' }" class="footer-link">About</router-link>
        <span class="footer-links__sep" aria-hidden="true">|</span>
        <router-link :to="{ name: 'en-disclaimer' }" class="footer-link">Disclaimer</router-link>
        <span class="footer-links__sep" aria-hidden="true">|</span>
        <router-link :to="{ name: 'en-privacy' }" class="footer-link">Privacy Policy</router-link>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'Footer',
};
</script>

<style lang="scss" scoped>
/* 页脚：整区深绿底，文案直接铺在背景上（无白卡片） */
.footer {
  background-color: #204f46;
  padding: 16px 0;
}

@media (max-width: 768px) {
  .footer {
    padding: 12px 0 50px;
  }
}

.footer-container {
  width: 90%;
  max-width: 1100px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  padding: 14px 18px;
  box-sizing: border-box;
  text-align: center;
}

.footer-links {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  align-items: center;
  justify-content: center;
  color: #fff;
  /* 比版权说明一行略小 */
  font-size: 13px;
}

.footer-links__sep {
  color: #fff;
  user-select: none;
}

.footer-note {
  font-size: 15px;
  color: #fff;
  max-width: 52rem;

  p {
    margin: 0;
    line-height: 1.55;
  }
}

@media (max-width: 768px) {
  .footer-note {
    font-size: 14px;
  }

  .footer-links {
    font-size: 12px;
  }
}
</style>

<style lang="scss">
/* 非 scoped：命中页脚内 <a.footer-link>，与 scoped 字号分工（链接行整体更小在 .footer-links） */
.footer a.footer-link {
  color: #fff;
  -webkit-text-fill-color: currentColor;
  text-decoration: none;
  font-size: inherit;
  transition: color 0.2s, text-decoration 0.2s;
  flex-shrink: 0;
  white-space: nowrap;
}

.footer a.footer-link:hover {
  color: #39f;
  text-decoration: underline;
  text-decoration-thickness: 1px;
}
</style>
